module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BaseModal__mask"
  }, [_c('div', {
    class: ['BaseModal', _vm.className]
  }, [_c('div', {
    staticClass: "BaseModal__header"
  }, [_c('BaseNavigationButton', {
    attrs: {
      "class-name": 'BaseModal__header-close',
      "icon": 'icon-left'
    },
    on: {
      "click": function($event) {
        _vm.close($event.target)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "BaseModal__header-title"
  }, [_vm._v("\n                " + _vm._s(_vm.translate(_vm.title)) + "\n            ")]), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'COMMON__SAVE',
      "class-name": 'BaseModal__header-save',
      "accent": true
    },
    on: {
      "click": function($event) {
        _vm.save($event.target)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "BaseModal__body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "BaseModal__bottom"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'COMMON__CLOSE',
      "class-name": 'BaseModal__close'
    },
    on: {
      "click": function($event) {
        _vm.close($event.target)
      }
    }
  }), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'COMMON__SAVE',
      "class-name": 'BaseModal__save',
      "accent": true
    },
    on: {
      "click": function($event) {
        _vm.save($event.target)
      }
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f30fca6e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseModal.vue
// module id = 532
// module chunks = 1